// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"UserDetail_loginPage__KT-jz","unit":"UserDetail_unit__26GBQ","statBlock":"UserDetail_statBlock__7FQz7","bg":"UserDetail_bg__3b_iF"};